import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { InvalidBrowserComponent } from "./common/component/invalid-browser/invalid-browser.component";
import { BrowserGuard } from "./common/guard/browser.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "home/GSF/eng",
    pathMatch: "full",
  },
  {
    path: "home",
    loadChildren: () =>
      import("./modules/home/home.module").then((m) => m.HomeModule),
  },
  {
    path: "recognition",
    loadChildren: () =>
      import("./modules/general/general.module").then((m) => m.GeneralModule),
  },
  {
    path: "innovations",
    loadChildren: () =>
      import(
        "./sustainability-innovations/sustainability-innovations.module"
      ).then((m) => m.SustainabilityInnovationsModule),
    canActivate: [BrowserGuard],
  },
  {
    path: "packaging",
    loadChildren: () =>
      import(
        "./packaging/sustainability-packaging.module"
      ).then((m) => m.SustainabilityPackagingModule),
    canActivate: [BrowserGuard],
  },
  {
    path: "nosupport",
    component: InvalidBrowserComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
  ],
  declarations: [],
  exports: [RouterModule],
})
export class AppRoutingModule {}
